"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrowserConsoleLogger = exports.ConsoleLogger = exports.browserFormatter = exports.defaultFormatter = exports.getLevelColor = exports.FgWhite = exports.FgCyan = exports.FgMagenta = exports.FgBlue = exports.FgYellow = exports.FgGreen = exports.FgRed = exports.FgBlack = exports.Reset = void 0;
const tslib_1 = require("tslib");
const __1 = require("..");
const _1 = require(".");
/**
 * Resets the console color
 */
exports.Reset = '\x1b[0m';
/**
 * Black console foreground color
 */
exports.FgBlack = '\x1b[30m';
/**
 * Red console foreground color
 */
exports.FgRed = '\x1b[31m';
/**
 * Green console foreground color
 */
exports.FgGreen = '\x1b[32m';
/**
 * Yellow console foreground color
 */
exports.FgYellow = '\x1b[33m';
/**
 * Blue console foreground color
 */
exports.FgBlue = '\x1b[34m';
/**
 * Magentaa console foreground color
 */
exports.FgMagenta = '\x1b[35m';
/**
 * Cyan console foreground color
 */
exports.FgCyan = '\x1b[36m';
/**
 * White console foreground color
 */
exports.FgWhite = '\x1b[37m';
/**
 * Returns an associated color to a specific log level
 */
const getLevelColor = (level, isBrowser = false) => {
    let color;
    switch (level) {
        case _1.LogLevel.Verbose:
            color = isBrowser ? _1.colors.darkblue : exports.FgBlue;
            break;
        case _1.LogLevel.Debug:
            color = isBrowser ? _1.colors.darkblue : exports.FgBlue;
            break;
        case _1.LogLevel.Information:
            color = isBrowser ? _1.colors.darkgreen : exports.FgGreen;
            break;
        case _1.LogLevel.Warning:
            color = isBrowser ? _1.colors.darkorange : exports.FgYellow;
            break;
        case _1.LogLevel.Error:
            color = isBrowser ? _1.colors.darkred : exports.FgRed;
            break;
        default:
            color = isBrowser ? _1.colors.darkred : exports.FgRed;
            break;
    }
    return color;
};
exports.getLevelColor = getLevelColor;
/**
 * The default formatter for the Console logger
 * @param entry the log entry to be formatted
 */
const defaultFormatter = (entry, isVerbose) => {
    const fontColor = exports.getLevelColor(entry.level);
    const formattedEntry = [`${fontColor}%s${exports.Reset}`, entry.scope, entry.message];
    return entry.data && isVerbose ? [...formattedEntry, entry.data] : formattedEntry;
};
exports.defaultFormatter = defaultFormatter;
/**
 * The formatter for browsers like Firefox, Chrome
 * @param entry the log entry to be formatted
 */
const browserFormatter = ({ level, message, data, scope }) => {
    if (!scope) {
        return data ? [message, data] : [message];
    }
    const fontColor = exports.getLevelColor(level, true);
    const formattedEntry = [`%c[${scope}]:`, `color: ${fontColor}`, message];
    return data ? [...formattedEntry, data] : formattedEntry;
};
exports.browserFormatter = browserFormatter;
/**
 * A logger implementation that dumps log messages to the console
 */
let ConsoleLogger = class ConsoleLogger extends _1.AbstractLogger {
    addEntry(entry, isVerbose = false) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const data = exports.defaultFormatter(entry, isVerbose);
            console.log(...data);
        });
    }
};
ConsoleLogger = tslib_1.__decorate([
    __1.Injectable({ lifetime: 'scoped' })
], ConsoleLogger);
exports.ConsoleLogger = ConsoleLogger;
let BrowserConsoleLogger = class BrowserConsoleLogger extends _1.AbstractLogger {
    addEntry(entry) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const data = exports.browserFormatter(entry);
            console.log(...data);
        });
    }
};
BrowserConsoleLogger = tslib_1.__decorate([
    __1.Injectable({ lifetime: 'scoped' })
], BrowserConsoleLogger);
exports.BrowserConsoleLogger = BrowserConsoleLogger;
//# sourceMappingURL=console-logger.js.map